import EventEmitter from 'events';
import { fabric } from 'fabric';
import { v4 as uuid } from 'uuid';


class Editor extends EventEmitter {
  constructor(canvas, option) {
    super();

    this.canvas = canvas
    this.editorWorkspace = null;

    // initAligningGuidelines(canvas);
    // initHotkeys(canvas);
    // initControls(canvas);
    // initControlsRotate(canvas);
    // this.centerAlign = new initCenterAlign(canvas);
  }
  /**
 * @param {Array} array  画布元素
 */
  selectedObjects (array) {
    this.canvas.discardActiveObject()
    const sel = new fabric.ActiveSelection(array, {
      canvas: this.canvas
    })
    this.canvas.setActiveObject(sel)
    this.canvas.requestRenderAll()
    this.canvas.renderAll()
  }

  /**
 * @param {fabric.Object} obj
 * @param {String} name  键
 * @param {String||Number} value 值
 */
  changeEquObject (obj, name, value) {
    if (obj.component === 'Equipment') {
      const equObject = obj.getObjects()[0]
      equObject.set(name, value)
    }
    this.canvas.requestRenderAll()
  }
  
  setPointActiveClassOff(target) {
    this.changeEquObject(target, 'shadow', '')
    this.changeEquObject(target, 'stroke', '')
  }

  setPointActiveClassOn(target) {
    try {
      if (target.statusType) {
        this.changeEquObject(target, 'stroke', '#E6A23C')
        return
      }
    } catch (error) {}
    this.changeEquObject(target, 'shadow', '5px 5px 6px rgba(0, 0, 0, 0.4)')
    if (target.isVirtual) {
      this.changeEquObject(target, 'stroke', '#48A3FF')
    } else {
      this.changeEquObject(target, 'fill', '#033B78')
    }
  }

  /**
 * @param {Array} array  画布元素
 */
  selectedObjectsActiveClass(Array){
    Array.forEach((obj) => {
      this.setPointActiveClassOn(obj)
    })
  }

  /**
 * @param {fabric.Object} obj
 * @param {String} name  键
 * @param {String||Number} value 值
 */
  changeEquObject (obj, name, value) {
    if (obj.component === 'Equipment') {
      const equObject = obj.getObjects()[0]
      equObject.set(name, value)
    }
    this.canvas.requestRenderAll()
  }

  /* 锁定画布 */
  lockMovementAll() {
    this.canvas.forEachObject((obj) => {
      obj.lockMovementX = true
      obj.lockMovementY = true
    })
    this.canvas.requestRenderAll()
  }

  /* 解锁画布 */
  unlockMovementAll() {
    this.canvas.forEachObject((obj) => {
      obj.lockMovementX = false
      obj.lockMovementY = false
    })
    this.canvas.requestRenderAll()
  }

  /* 点击点位房间高亮 */
  setSelectPointAndRoomActiveClassOn = (target) => {
    this.changeEquObject(target, 'fill', 'rgba(68, 161, 242, 0.26)')
    this.changeEquObject(target, 'stroke', '5px 5px 6px rgba(0, 0, 0, 0)')
  }
  
  /* 设置传感器颜色 */
  setSensorColor = (target,statusValue = '0') => {
    const sensor = target.getObjects()
    sensor.forEach((obj) => {
      if(statusValue === '0') {
        if(obj.component === 'wave') {
          obj.set('fill', 'rgba(130, 130, 130, 0.3)')
        }else if(obj.component === 'wave1') {
          obj.set('fill', 'rgba(130, 130, 130, 0.2)')
        }else if(obj.component === 'wave2') {
          obj.set('fill', 'rgba(130, 130, 130, 0.1)')
        }
      }else if(statusValue === '1'){
        if(obj.component === 'wave') {
          obj.set('fill', 'rgba(94, 215, 255, 0.3)')
        }else if(obj.component === 'wave1') {
          obj.set('fill', 'rgba(94, 215, 255, 0.2)')
        }else if(obj.component === 'wave2') {
          obj.set('fill', 'rgba(94, 215, 255, 0.1)')
        }
      }else if(statusValue === '2'){
        if(obj.component === 'wave') {
          obj.set('fill', 'rgba(0,0,0,0)')
        }else if(obj.component === 'wave1') {
          obj.set('fill', 'rgba(0,0,0,0)')
        }else if(obj.component === 'wave2') {
          obj.set('fill', 'rgba(0,0,0,0)')
        }
      }
      
    })
    this.canvas.requestRenderAll()
    this.canvas.renderAll()
  }

}

export default Editor;